import * as React from 'react'
import { useEffect, useState } from 'react'
import { timeout } from '../../App'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import { AddAlert } from '@material-ui/icons'
import Snackbar from '../snackbar/Snackbar'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { initialNotificationState } from '../utils/state/ApplicationState'

import styles from 'assets/jss/dorm-app/components/cardStyle.js'
import { makeStyles } from '@material-ui/core/styles'
import { Extension } from './Extension'
import { stringifyDate } from '../utils/DateUtils'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

export default function ProcessingExtensionTable() {
  const classes = useStyles()

  const [notification, setNotification] = useState(initialNotificationState)

  const [proceeding, setProceeding] = useState(false)

  const [moveOutList, setMoveOutList] = useState([])

  const [claims, setClaims] = useState([])

  useEffect(() => {
    setProceeding(true)
    getApiUrl({ status: 'PROCESSING', type: 'EXTENSION' })
      .get(`/admin/claims`)
      .then(function(response) {
        setClaims(response.data)
        setMoveOutList(new Array(response.data.length).fill(null))
        setProceeding(false)
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
      })
  }, [notification])

  const handleAcceptExtension = (departureId, moveOut) => {
    setProceeding(true)

    getApiUrl()
      .patch(`/admin/claims/${departureId}/approve`, { moveOut: stringifyDate(moveOut) })
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Bewerbung um Wohnzeitverlängerung  genehmigt.',
          color: 'success',
        })
      })
      .catch(function(error) {
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const handleRejectExtension = (departureId) => {
    setProceeding(true)
    getApiUrl()
      .patch(`/admin/claims/${departureId}/reject`)
      .then(function() {
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Bewerbung um Wohnzeitverlängerung abgelehnt',
          color: 'success',
        })
      })
      .catch(function(error) {
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />

      {claims.length !== 0 ? (
        claims.map((row, index) => (
          <React.Fragment key={row.claimId}>
            <GridItem xs={12} sm={6} md={6} lg={3}>
              <Extension
                claimId={row.claimId}
                moveOutList={moveOutList}
                index={index}
                tenant={row.tenant}
                handleAcceptExtension={handleAcceptExtension}
                handleRejectExtension={handleRejectExtension}
                setMoveOutList={setMoveOutList}
              />
            </GridItem>
          </React.Fragment>
        ))
      ) : (
        <h4 className={classes.header}>Keine Verlängerungen in Bearbeitung</h4>
      )}
      <GridContainer></GridContainer>
    </GridContainer>
  )
}
